  
import { 
    LOGIN_SUCCESS,
    LOGOUT_SUCCESS,
    LOGOUT_FAIL,
    GET_USER_ICON_PATH, 
    GET_NOTIFICATIONS, 
    REMOVE_NOTIFICATION, 
    READ_NOTIFICATION,
    TOGGLE_SIDEBAR, 
    SET_SIDEBAR_PAGE, 
} from "../actions/types";

const initialState = {
  user_icon_path: {},
  notifications: [],
  sidebarIsDefault: true,
  sidebarActivePage: "",
};

export default function (state = initialState, action) {
  switch (action.type) {
    // ensure no redux values linger between users ----
    case LOGIN_SUCCESS:
    case LOGOUT_SUCCESS:
    case LOGOUT_FAIL:
        return {
            ...initialState,
        }
    // ------------------------------------------------  
    case GET_USER_ICON_PATH:
      return {
        ...state,
        user_icon_path: action.payload
      };
      case GET_NOTIFICATIONS:
        return {
          ...state,
          notifications: action.payload
        };
      case REMOVE_NOTIFICATION:
        return {
          ...state,
          notifications: state.notifications.filter((notification) => notification.notification_id !== action.payload)
          //notifications: action.payload
        };
      case READ_NOTIFICATION:
        return {
          ...state,
          notifications: state.notifications.map((notification) => notification.notification_id === action.payload ? {...notification, read: true} : notification)
        };
      case TOGGLE_SIDEBAR:
        return {
          ...state,
          sidebarIsDefault: !state.sidebarIsDefault
        };
      case SET_SIDEBAR_PAGE:
        return {
          ...state,
          sidebarActivePage: action.payload
        };
    default:
      return state;
  }
}